<template>
    <v-simple-table dense>
        <template v-slot:default>
            <tbody>
                <tr>
                    <th>Institusi</th>
                    <td>: {{ data.nama_institusi }}</td>
                    <td></td>
                    <th>Program Studi</th>
                    <td>: {{ data.nama_prodi }}</td>
                </tr>
                <tr>
                    <th>Kelompok</th>
                    <td>: {{ data.profesi }}</td>
                    <td></td>
                    <th>Tanggal Awal</th>
                    <td>: {{ formatDate(data.tanggal_awal) }}</td>
                </tr>
                <tr>
                    <th>Stase</th>
                    <td>: {{ data.nama_stase }}, {{ data.stase }}</td>
                    <td></td>
                    <th>Tanggal Akhir</th>
                    <td>: {{ formatDate(data.tanggal_akhir) }}</td>
                </tr>
                <tr>
                    <th>Nama/Keterangan</th>
                    <td>: {{ data.nama }}</td>
                    <td></td>
                    <th></th>
                    <td></td>
                </tr>
                <tr>
                    <th>File Jadwal</th>
                    <td>: <a target="_blank" :href="data.file_url">Lihat
                            File</a></td>
                    <td></td>
                    <th>File SPT</th>
                    <td>: <a target="_blank" :href="data.file_spt_url">Lihat
                            File</a></td>
                </tr>
                <tr>
                    <th>File Pengantar</th>
                    <td>: <a v-if="data.file_pengantar_name != null" target="_blank"
                            :href="data.file_pengantar_url">Lihat
                            File</a></td>
                    <td></td>
                    <th v-if="user.role == 'ADMIN' || user.role == 'UNIVERSITAS'">File Jawaban</th>
                    <td v-if="user.role == 'ADMIN' || user.role == 'UNIVERSITAS'">: <a
                            v-if="data.file_jawaban_name != null" target="_blank" :href="data.file_jawaban_url">Lihat
                            File</a></td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
export default {
    props: {
        data: { type: Object, default: () => ({}) },
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
    },
}
</script>